<template>
	<div v-show="bodyIsShow" class="bodywrap">
		<header> 
		    <a class="fl searchHeader-back" href="javascript:window.history.go(-1)"></a>
		    <span class="title">报名成功</span> 
	    </header>
	     <!-- 超级购活动开始 --> 
	     <!--<if condition="($isBuy eq 1) ">-->
	      <!--  <a v-if="isBuy == 1" class="clearfix" style="display:block;width:100%" :href="superBuyUrlPath">
	         <img style="float:left;width:100%" :src="bannerPic" />
	       </a> -->
	     <!--</if>-->
	   <!-- 超级购活动结束 -->
	    
		<section class="signUp-success">
			<div class="border-section">
				<div class="signUp-success-beauty"></div>
				<p class="signUp-success-congratulation">恭喜您报名成功！</p>
				<p class="red" style="font-size:14px;text-align:left;padding:0 1em;">车展时间：报名成功后客服人员会通知您参展时间</p>
				<p class="red" style="font-size:14px;text-align:left;padding:0 1em; margin-bottom:1em;">车展价格：现场公布</p>
			</div>
	         <!-- 康得新结束 -->
			<div class="signUp-customer-service border-section">
				<div class="fl">团车网客服：<a href="tel:4001-501-501"><button class="tel">4001-501-501</button></a></div>
				<div class="fl">客服工作时间：<span class="time">09:00-18:00</span></div>
			</div>
		</section>
		<section class="signUp-zhidao">
			<!-- <p class="signUp-zhidao-tit">团车知道</p> -->
			<!-- <ul class="signUp-zhidao-ul"> -->
				<!--<foreach name="topiclist" item="topic">-->
				<!-- <li v-for="(item,index) in topiclist" class="clearfix">
					<div class="lanmu_img fr">
					<a :href="host_name+'/ask/h'+item.id+'.html'">
					     <img class="scrollLoading img" :src="pic_url+'/zixun'+item.picture+'_s.jpg'" :data-url="pic_url+'/zixun'+item.picture+'_s.jpg'">
					     </a>
					</div>
					<div class="lanmu_newsL fl">
						<p class="lanmu_tit Tit"><a :href="host_name+'/ask/h'+item.id+'.html'">{{item.title}}</a></p>
						<p class="lanmu_txt">
							<span class="pub_date">浏览{{item.clickCount}}次</span>
							<span class="click_num">{{item.replyCount}}评论</span>
						</p>
					</div>
				</li> -->
				<!--</foreach>-->
			<!-- </ul> -->
			<div class="clearfix signUp-zhidao-link">
				<a :href="host_name+'/ask/l113/'">摇号</a>
				<a :href="host_name+'/ask/l9/'">报价</a>
				<a :href="host_name+'/ask/l12/'">油耗</a>
				<a :href="host_name+'/ask/l27/'">保养</a>
				<a :href="host_name+'/ask/l6/'">二手车</a>
			</div>
		</section>
	</div>    
</template>
<style scoped>
	.signUp-success-beauty {
	    height: 1.4rem;
	    background-size: 1.4rem 1.4rem;
	    margin-bottom: 0.2rem;
	}
	.signUp-success-congratulation {
	    font-size: 0.5rem;
	    line-height: 0.7rem;
	}
	.signUp-customer-service > div {
	    font-size: 0.3rem;
	}
	.signUp-customer-service .time {
	    font-size: 0.3rem;
	}
	.signUp-customer-service .time {
	    font-size: 0.3rem;
	}
	.signUp-customer-service .tel {
	    font-size: 0.3rem;
	}
	.signUp-customer-service {
	    line-height: 1rem;
	}
	.signUp-zhidao-tit {
	    line-height: 1rem;
	    height: 1rem;
	    font-size: 0.3rem;
	}
</style>
<script>
export default {
	name: 'detailCarstyle',
	data:function() {
		return {
			bodyIsShow:false,
			isBuy:2,
			is_rrcar:1,
			superBuyUrlPath:'',
			bannerPic:'',
			host_name:'',
			topiclist:[],
			pic_url:''
			
		}
	},
	beforeCreate:function(){
		getCommonJsIns.initCSSwap02({
			cssURL:"/css/commons/common.css"
		});
		getCommonJsIns.initCSSwap02({
			cssURL:"/css/default/usedcar.css"
		});
		getCommonJsIns.initCSSwap02({
			cssURL:"/css/default/signUp-success.css"
		});
	},
	mounted:function(){
		var self = this;
		document.title="品牌"
		getCommonJsIns.initJSwap02({
			jsURL:"/script/default/signpsuccess.js",
			callback:function(){
				self.webReady()
			}
		});
	},
	methods:{
		webReady:function(){
			this.bodyIsShow = true;
			
		},
		handleinput:function(event){
            if (event.target.value =='请输入行驶里程'){
            	event.target.value  =''
            }
        },
        blur:function(event){
        	if (event.target.value ==''){
        		event.target.value='请输入行驶里程'
        	}
        }
	}
}
</script>


// WEBPACK FOOTER //
// src/views/signupPhp/success.vue